import { string } from "prop-types";
import React, { memo } from "react";

import Typography from "components/shared/Typography";

const EXPRESSION = {
  LIST_ITEM: "- ",
  NEW_LINE: "\\n",
};

const ITEM_TYPE = {
  LIST_ITEM: "LIST_ITEM",
  TEXT: "TEXT",
};

const PackageDetailDescription = ({ description }) => {
  let currentList = [];
  const content = [];

  const items = description
    .split(EXPRESSION.NEW_LINE)
    .map(line => line.trim())
    .map(line => {
      if (line.startsWith(EXPRESSION.LIST_ITEM)) {
        return {
          content: line.substr(EXPRESSION.LIST_ITEM.length),
          type: ITEM_TYPE.LIST_ITEM,
        };
      }

      return {
        content: line,
        type: ITEM_TYPE.TEXT,
      };
    });

  items.forEach((item, idx) => {
    if (item.type === ITEM_TYPE.LIST_ITEM) {
      currentList.push(
        <li className="ml-2" key={`${idx}-${item.content}`}>
          <Typography className="min-h-4 text-sm/normal">
            {item.content}
          </Typography>
        </li>
      );
    } else {
      if (currentList.length > 0) {
        content.push(
          <ul className="p-4 text-black list-disc" key={`${idx}-ul`}>
            {currentList}
          </ul>
        );
        currentList = [];
      }
      content.push(
        <Typography
          className="min-h-4 text-sm/normal"
          key={`${idx}-${item.content}`}
        >
          {item.content}
        </Typography>
      );
    }
  });

  // when the last item was a list item, list does not get closed and rendered, so let's check again
  if (currentList.length > 0) {
    content.push(
      <ul className="p-4 text-black list-disc" key={`last-ul`}>
        {currentList}
      </ul>
    );
    currentList = [];
  }

  return <>{content}</>;
};

PackageDetailDescription.propTypes = {
  description: string.isRequired,
};

// component is being rerendered on many surrounding state changes (other accordions open/close, journey switch)
// memo hides /possibly expensive/ string processing and react structure rendering from each render
// recalculation happens only on first render and then on props (description) change
export default memo(PackageDetailDescription);
